import { Navigate, Outlet } from "react-router"

export const ProtectedLayout =()=>{
    const token =localStorage.getItem("token")
    localStorage.setItem("beforeLogin",window.location.pathname)
    if(!token|| token =="null"){
      return  <Navigate to="/login"  />
    }

return <Outlet/>;}